/**
 * Reopen the modal containing a Gravity Forms form after a regular submit.
 */

const getModalForForm = ( form ) => form.closest( '[id^="modal-"]' );

const getModalForFormFragment = ( formId ) => {
	const form = document.querySelector( `#gform_${ formId }` );
	const anchor = document.querySelector( `#gf_${ formId }` );

	return ( form || anchor )?.closest( '[id^="modal-"]' );
};

const getFormFragmentId = () => window.location.hash.match( /^#gf_(\d+)$/ )?.[1];

const alignFormFragment = ( formId = getFormFragmentId() ) => {
	const form = formId && document.querySelector( `#gform_${ formId }` );
	const target = form?.closest( '.campaign-donation-card' ) || form?.closest( '.gform_wrapper' );

	if ( ! target || target.closest( '[id^="modal-"]' ) ) {
		return;
	}

	document.dispatchEvent( new CustomEvent( 'samenwerk:align-fragment-target', {
		detail: { target },
	} ) );
};

const openModalFromFormFragment = () => {
	const formId = window.location.hash.match( /^#gf_(\d+)$/ )?.[1];

	if ( ! formId ) {
		return;
	}

	const form = document.querySelector( `#gform_${ formId }` );
	const modal = form ? getModalForForm( form ) : getModalForFormFragment( formId );

	if ( ! modal || modal.offsetParent !== null ) {
		return;
	}

	window.location.hash = modal.id;
};

const initialize = () => {
	openModalFromFormFragment();
	window.setTimeout( alignFormFragment, 0 );
	document.addEventListener( 'hashchange', openModalFromFormFragment );
	document.addEventListener( 'hashchange', alignFormFragment );
	document.addEventListener( 'focusin', ( event ) => {
		if ( event.target?.classList?.contains( 'gform_anchor' ) ) {
			window.setTimeout( alignFormFragment, 0 );
		}
	} );

	if ( window.jQuery ) {
		window.jQuery( document ).on( 'gform_post_render.samenwerkFragment', () => {
			window.setTimeout( alignFormFragment, 0 );
		} );
	}
};

const initializeOnReady = {
	loading: () => document.addEventListener( 'DOMContentLoaded', initialize ),
	interactive: initialize,
	complete: initialize,
}[ document.readyState ];

initializeOnReady();
